function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 14.5L7.45 11.6C7.61696 11.2687 7.87281 10.9903 8.18893 10.796C8.50504 10.6018 8.86897 10.4993 9.24 10.5H20M20 10.5C20.3055 10.4995 20.6071 10.5689 20.8816 10.7031C21.1561 10.8372 21.3963 11.0325 21.5836 11.2739C21.7709 11.5152 21.9004 11.7963 21.9622 12.0956C22.024 12.3948 22.0164 12.7042 21.94 13L20.39 19C20.279 19.4299 20.0281 19.8106 19.6769 20.0822C19.3256 20.3538 18.894 20.5008 18.45 20.5H4C3.46957 20.5 2.96086 20.2893 2.58579 19.9142C2.21071 19.5391 2 19.0304 2 18.5V5.5C2 4.4 2.9 3.5 4 3.5H7.93C8.25941 3.5017 8.58331 3.58475 8.8729 3.74176C9.1625 3.89877 9.40882 4.12488 9.59 4.4L10.41 5.6C10.5912 5.87512 10.8375 6.10123 11.1271 6.25824C11.4167 6.41525 11.7406 6.4983 12.07 6.5H18C18.5304 6.5 19.0391 6.71071 19.4142 7.08579C19.7893 7.46086 20 7.96957 20 8.5V10.5Z",
  stroke: "black",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFolderIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder-icon.bd69f289.svg";
export { ForwardRef as ReactComponent };